var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-toolbar',[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('md-icon',[_vm._v("keyboard_backspace")])],1),_c('span',[_vm._v(_vm._s(_vm.title))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }